import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use((config) => {
  const isAuthRoute = config.url?.startsWith('/auth/');
  if (!isAuthRoute) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

/**
 * Thin axios wrapper with the same interface as the previous fetch client.
 * - Accepts { method, body, headers, ...rest }
 * - Returns response data directly
 * - Throws an Error with the server's message on non-2xx status
 */
const apiClient = async (endpoint, options = {}) => {
  const { body, headers = {}, method = 'GET', ...rest } = options;

  try {
    const response = await axiosInstance({
      url: endpoint,
      method,
      data: body,
      headers,
      ...rest,
    });

    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      (typeof error.response?.data === 'string' && error.response.data) ||
      error.message ||
      'Request failed';
    throw new Error(message);
  }
};

export default apiClient;
